import getSocialMediaIcon from './GetSocialMediaIcon';
import getSocialMediaUrl from './GetSocialMediaUrl';

const returnObject = {
  getSocialMediaUrl,
  getSocialMediaIcon,
};

export default returnObject;
